import { z } from 'zod'

export const CreateCustomerSchema = z.object({
  name: z
    .string({ required_error: 'Müşteri adı zorunludur.' })
    .min(2, 'Müşteri adı en az 2 karakter olmalıdır.')
    .max(200),
  contactPerson: z.string().max(100).nullable().optional(),
  contactEmail: z.string().email('Geçerli bir e-posta adresi giriniz.').max(255).nullable().optional(),
  contactPhone: z.string().max(50).nullable().optional(),
  sector: z.string().max(100).nullable().optional(),
  address: z.string().max(1000).nullable().optional(),
  notes: z.string().max(2000).nullable().optional(),
  tags: z.array(z.string().max(50)).max(20).optional().default([]),
})

export const UpdateCustomerSchema = CreateCustomerSchema.partial()

export type CreateCustomerInput = z.infer<typeof CreateCustomerSchema>
export type UpdateCustomerInput = z.infer<typeof UpdateCustomerSchema>
